import { signalStoreFeature, withComputed } from '@ngrx/signals';
import { IQueueStore } from './queue.public';

export function withQueues(queueStore: IQueueStore) {
    return signalStoreFeature(
        withComputed(() => ({
            queues: queueStore.queues,
        })),
    );
}
